import { container } from '../container/Container';
import { ApiClient } from '../../infrastructure/api/ApiClient';
import { UserRepositoryImpl } from '../../infrastructure/repositories/UserRepositoryImpl';
import { UserDomainService } from '../../domain/services/UserDomainService';
import { CreateUserUseCase } from '../../application/use-cases/CreateUserUseCase';
import { GetUserUseCase } from '../../application/use-cases/GetUserUseCase';
import { UserService } from '../../application/services/UserService';

export const setupDependencyInjection = () => {
  container.singleton('ApiClient', () => new ApiClient());
  
  container.register('UserRepository', () => 
    new UserRepositoryImpl(container.get('ApiClient'))
  );
  
  container.singleton('UserDomainService', () => new UserDomainService());
  
  container.register('CreateUserUseCase', () => 
    new CreateUserUseCase(
      container.get('UserRepository'),
      container.get('UserDomainService')
    )
  );
  
  container.register('GetUserUseCase', () => 
    new GetUserUseCase(container.get('UserRepository'))
  );
  
  container.register('UserService', () => 
    new UserService(
      container.get('CreateUserUseCase'),
      container.get('GetUserUseCase')
    )
  );
};
